<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  template: '',
  watch: {
    lastPage() {
      this.checkPageBoundaries();
    },
    value(newVal) {
      this.page = newVal;
      this.checkPageBoundaries();
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  methods: {
    setPage(target) {
      this.$emit('input', target);
      this.page = target;
    },
    checkPageBoundaries() {
      if (this.lastPage > 0 && this.page > this.lastPage) {
        this.goToLastPage();
      }
      if (this.page < 1) {
        this.goToFirstPage();
      }
    },
    goToFirstPage() {
      this.setPage(1);
    },
    goToLastPage() {
      this.setPage(this.lastPage);
    },
    goToPrevPage() {
      if (this.prevAvailable) {
        this.setPage(this.page - 1);
      }
    },
    goToNextPage() {
      if (this.nextAvailable) {
        this.setPage(this.page + 1);
      }
    },
  },
  computed: {
    currentItems() {
      return this.items.slice((this.page - 1) * this.perPage, this.page * this.perPage);
    },
    totalPages() {
      return Math.ceil(this.items.length / this.perPage);
    },
    lastPage() {
      return this.totalPages;
    },
    hasMultiplePages() {
      return this.totalPages > 1;
    },
    prevAvailable() {
      return this.page > 1;
    },
    nextAvailable() {
      return this.totalPages > this.page;
    },
    passedScope() {
      return {
        page: this.page,
        currentItems: this.currentItems,
        totalPages: this.totalPages,
        prevAvailable: this.prevAvailable,
        nextAvailable: this.nextAvailable,
      };
    },
  },
  props: {
    value: {
      default: 1,
      type: Number,
      validator(value) {
        return value > 0;
      },
    },
    items: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
});
</script>
<template>
  <div>
    <slot v-bind="passedScope" />
    <slot name="controls">
      <div v-if="hasMultiplePages">
        <el-button-group class="bu-p-4">
          <el-button
            size="small"
            :disabled="!prevAvailable"
            icon="el-icon-caret-left"
            @click="goToPrevPage"
          />
          <el-button
            size="small"
            :disabled="!nextAvailable"
            icon="el-icon-caret-right"
            @click="goToNextPage"
          />
        </el-button-group>
      </div>
    </slot>
  </div>
</template>
